import React, { useEffect, useState } from "react";
import { Button, Text } from "components";
import Modal from "react-modal";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";

const JobWorkInwardtoStore = () => {
  const [visible, setvisible] = useState(true);
  const [wareHouse, setwareHouse] = useState([]);
  const [CompanyPurchase, setCompanyPurchase] = useState([]);
  const [checkedQuantities, setCheckedQuantities] = useState([]);
  const [selectedWarehouseType, setSelectedWarehouseType] = useState("single");
  const [selectedWarehouses, setSelectedWarehouses] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  let navigate = useNavigate();

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const [unique, setunique] = useState([]);
  const [erplist, setErplist] = useState([]);
  useEffect(() => {
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  useEffect(() => {
    companywarehouseget();
    fetchData();
  }, []);

  const companyWarehouse_obj = {};
  const companywarehouseget = () => {
    axios
      .post(
        "/api/purple-fusion/companywarehouse/get",
        companyWarehouse_obj,
        headers
      )
      .then((response) => {
        setwareHouse(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const validationSchema = Yup.object().shape({
    po_wo_inv_other_detail: Yup.string().required(
      "Comapany purchase order code is required"
    ),
  });
  const formik = useFormik({
    initialValues: {
      item_detail_id: "",
      transaction_type_id: "11",
      company_warehouse_id: "",
      company_purchase_order_entry_id:
        checkedQuantities[0]?.company_purchase_order_id,
      quantity: "",
      po_wo_inv_other_id: "",
      po_wo_inv_other_detail: "",
      description: "NA",
      supplier_id: "",
      supplier_delivery_challan:"",
      company_purchase_order_id:"",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });

  console.log(formik.values.company_purchase_order_id);

  const requestPayload = {
    company_purchase_order_id:0,
    offset:0,
    limit:0,
    search_company_specific_criteria_id:0,
    search_company_specific_date_range_id:0,
    search_parameter:"",
  };
  
  const fetchData = () => {
    axios
      .post(
        "/api/purple-fusion/stocktransaction/get/companypurchaseorder/ckeck/waitingforinward",
        requestPayload,
        { ...headers, timeout: 20000 }
      )
      .then((res) => {
        if (res.data && Array.isArray(res.data) && res.data.length > 0) {
          console.log(res.data);
        const filterdata = res.data.filter((item)=> item.company_purchase_order_type_id===10)

          setCompanyPurchase(filterdata);
          console.log(unique);
          
        } else {
          console.log(res.data);
        }
      })
      .catch((e) => {
        console.log("Error in featcheing data", e);
      });
  };

  const filteredbySupplerID = CompanyPurchase.filter((resgststatecode) => {
    if (resgststatecode.supplier_id === formik.values.supplier_id) {
      return resgststatecode;
    }
    return "";
  });

  const filteredPurchase = CompanyPurchase.filter((resDistrict) => {
    if (resDistrict.code === formik.values.po_wo_inv_other_detail) {
      return resDistrict;
    }

    return "";
  });

  if (filteredPurchase.length > 0) {
    formik.values.po_wo_inv_other_id = filteredPurchase[0].id;
  }

  useEffect(() => {

    CompanyPurchasechecked();
  }, [formik.values.company_purchase_order_id,formik.values.supplier_delivery_challan]);

  const chech_obj = {
    company_purchase_order_id: formik.values.company_purchase_order_id,
    supplier_delivery_challan:formik.values.supplier_delivery_challan

  };

  const CompanyPurchasechecked = () => {
    console.log(chech_obj, "check");
    axios
      .post(
        "/api/purple-fusion/stocktransaction/get/companypurchaseorder/ckeck",
        chech_obj,
        headers
      )
      .then((response) => {
        const itemsWithChecked = response.data.map((item) => ({
          ...item,
          checked: false,
          description: null,
        }));
        setCheckedQuantities(itemsWithChecked);
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // console.log(checkedQuantities);

  const handleToggle = (itemId) => {
    setCheckedQuantities((prevItems) => {
      const updatedItems = prevItems.map((item) =>
        item.id === itemId
          ? {
              ...item,
              checked: !item.checked,
              warehouse: item.checked ? null : selectedWarehouses[itemId],
              description: item.description || "",
            }
          : item
      );

      const allChecked = updatedItems.every((item) => item.checked);

      setSelectAllChecked(allChecked);

      setSelectedWarehouses((prevSelected) => ({
        ...prevSelected,
        [itemId]: updatedItems.find((item) => item.id === itemId)?.checked
          ? null
          : prevSelected[itemId],
      }));

      return updatedItems;
    });
  };

  // const handleSelectAll = () => {
  //   setCheckedQuantities((prevItems) => {
  //     const allChecked = !selectAllChecked;

  //     return prevItems.map((item) => ({ ...item, checked: allChecked }));
  //   });

  //   setSelectAllChecked(!selectAllChecked);
  // };

  const handleSelectAll = () => {
    setCheckedQuantities((prevItems) => {
      const allChecked = !selectAllChecked;

      return prevItems.map((item) => ({
        ...item,
        checked:
          searchTerm === "" ||
          item.item_name.toLowerCase().includes(searchTerm.toLowerCase())
            ? allChecked
            : item.checked,
      }));
    });
    setSelectAllChecked(!selectAllChecked);
  };

  const handleWarehouseTypeChange = (event) => {
    setSelectedWarehouseType(event.target.value);
    if (event.target.value === "multiple") {
      formik.setFieldValue("company_warehouse_id", null);
    }
  };

  useEffect(() => {
    setCompanyPurchase((prevItems) =>
      prevItems.map((item) => ({ ...item, checked: false }))
    );

    setSelectAllChecked(false);
  }, [formik.values.supplier_id]);

  // console.log("checkquantityid",checkquantityid);
  const handleFormSubmit = () => {
    const newArray = checkedQuantities
      .filter((item) => item.checked === true)
      .map((item) => ({
        item_detail_id: item.item_detail_id,
        transaction_type_id: "11",
        company_warehouse_id: formik.values.company_warehouse_id
          ? formik.values.company_warehouse_id
          : item.warehouse,
        quantity: item.quantity_accepted,
        po_wo_inv_other_id: formik.values.company_purchase_order_id,
        po_wo_inv_other_detail: formik.values.po_wo_inv_other_detail,
        company_purchase_order_entry_id: item.id,
        description: item.description,
        actual_document_no:item.supplier_delivery_challan
      }));
    console.log(newArray);
    if (newArray.length === 0) {
      toast.error("Atleast select one item", {
        autoClose: 2000,
      });
    } else {
      console.log(newArray);
      
      axios
        .post("/api/purple-fusion/stocktransaction/create", newArray, headers)
        .then((response) => {
          console.log(response.data);
          const message = response.data.message;
          response.data.status
            ? toast.success(message, {
                autoClose: 2000,
                onClose: () => {
                  setvisible(false);
                  navigate(`/stocktransaction/purchaselist`);
                },
              })
            : toast.error(message, {
                autoClose: 2000,
              });
        })
        .catch((error) => {
          console.log(error);
          setvisible(false);
          navigate("*");
        });
    }
  };

  const handleDescriptionChange = (itemId, value) => {
    setCheckedQuantities((prevItems) =>
      prevItems.map((item) =>
        item.id === itemId ? { ...item, description: value } : item
      )
    );
  };

  const sortedCompanyPurchase = CompanyPurchase.slice().sort(
    (a, b) => b.id - a.id
  );

  const customStyle = {
    content: {
      width: "70%",
      hieght: "80%",
      margin: "auto",
    },
    overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
  };

  return (
    <div>
      {erplist.some((item) => item.erp_module_id == 20 && item.add) ? (
        <div>
          <Modal
            isOpen={visible}
            style={customStyle}
            onRequestClose={() => {
              // setvisible(false);
              // navigate(`/stocktransaction/purchaselist`);
            }}
          >
            <form onSubmit={formik.handleSubmit}>
              <div className="bg-white-A700 flex flex-col font-inter items-center justify-start mx-auto w-full">
                <div className="flex md:flex-col flex-row md:gap-5 items-start justify-evenly w-full">
                  <div className="flex flex-1 flex-col gap-[19px] justify-start md:px-5 w-full">
                    <div>
                      <div className="flex flex-row items-center justify-start ">
                        <div className="flex flex-row  items-start justify-between w-full ">
                          <Text
                            className="mt-[5px] md:text-xl sm:text-[24px] text-base text-black-900 tracking-[0.20px]"
                            size="txtInterMedium24"
                          >
                            Add New Stock Purchase Inward
                          </Text>
                        </div>
                        <div className="flex flex-row items-center justify-end ml-auto top-2 ">
                          <Button
                            className="cursor-pointer font-medium mb-1.5 min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px] active:scale-90 transition-transform duration-200"
                            shape="round"
                            color="blue_A700"
                            size="base"
                            variant="fill"
                            type="submit"
                          >
                            Save
                          </Button>
                          <Button
                            className="cursor-pointer font-medium mb-3 min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px] "
                            shape="round"
                            color="white"
                            size="base"
                            variant="fill"
                            se
                            onClick={() => {
                              setvisible(false);
                              navigate(`/stocktransaction/purchaselist`);
                            }}
                          >
                            ╳
                          </Button>
                        </div>
                      </div>
                      <ToastContainer />
                      <div className="flex flex-col items-center justify-start mt-4 w-full">
                        <div className="md:gap-5 gap-x-[75px] gap-y-[10px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-900 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                Select WareHouse
                              </span>
                              <span className="text-red-A700 font-inter font-samll text-sm">
                                *
                              </span>
                            </Text>
                            <div className="flex items-center justify-start gap-4">
                              <label>
                                <input
                                  type="radio"
                                  value="single"
                                  checked={selectedWarehouseType === "single"}
                                  onChange={handleWarehouseTypeChange}
                                />
                                Single
                              </label>
                              <label>
                                <input
                                  type="radio"
                                  value="multiple"
                                  checked={selectedWarehouseType === "multiple"}
                                  onChange={handleWarehouseTypeChange}
                                />
                                Multiple
                              </label>
                            </div>
                          </div>
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full  mb-2">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-samll text-sm">
                                Supplier purchase order Code & Supplier Delivery Challan
                              </span>
                              <span className="text-red-A700 font-inter font-samll text-sm">
                                *
                              </span>
                            </Text>
                            <Select
                              name="po_wo_inv_other_detail"
                              options={sortedCompanyPurchase.map(
                                (resstate) => ({
                                  // label: resstate.code,
                                  label: `${resstate.code} ${'\u00A0'.repeat(5)}${resstate.supplier_delivery_challan}`,
                                  value: `${resstate.code} ${'\u00A0'.repeat(5)}${resstate.supplier_delivery_challan}`,
                                  supplier_delivery_challan:resstate.supplier_delivery_challan,
                                  po_wo_inv_other_detail:resstate.code,
                                  company_purchase_order_id:resstate.company_purchase_order_id
                                })
                              )}
                              className="bg-white-A700 border border-gray-200_02 border-solid h-9 rounded-[5px] w-full"
                              onChange={(selectedOption) => {
                                formik.setFieldValue(
                                  "po_wo_inv_other_detail",
                                  selectedOption.po_wo_inv_other_detail
                                );
                                formik.setFieldValue(
                                  "supplier_delivery_challan",
                                  selectedOption.supplier_delivery_challan
                                );
                                formik.setFieldValue(
                                  "company_purchase_order_id",
                                  selectedOption.company_purchase_order_id
                                );
                              }}
                              onBlur={formik.handleBlur}
                              placeholder="Select Code"
                              required
                            />
                            {formik.touched.po_wo_inv_other_detail &&
                            formik.errors.po_wo_inv_other_detail ? (
                              <div className="text-red-500">
                                {formik.errors.po_wo_inv_other_detail}
                              </div>
                            ) : null}
                          </div>
                          <div className="mt-1">
                            {/* Conditionally render warehouse selection based on the selected type */}
                            {selectedWarehouseType === "single" && (
                              <Select
                                name="company_warehouse_id"
                                options={wareHouse.map((resstate) => ({
                                  label: resstate.warehouse_name,
                                  value: resstate.id,
                                }))}
                                className="bg-white-A700 border border-gray-200_02 border-solid h-9 rounded-[5px] w-full"
                                onChange={(selectedOption) => {
                                  formik.setFieldValue(
                                    "company_warehouse_id",
                                    selectedOption.value
                                  );
                                }}
                                onBlur={formik.handleBlur}
                                placeholder="Select WareHouse"
                                required
                              />
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col items-center justify-start mt-4 w-full ">
                        <div className="md:gap-5 gap-x-[75px] gap-y-[25px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                          <div className="flex">
                            <input
                              type="text"
                              placeholder="Search..."
                              className="bg-white-A700 border border-gray-400_02 border-solid  h-9 rounded-[5px] mb-0 w-full"
                              value={searchTerm}
                              onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setSelectAllChecked(
                                  checkedQuantities.filter(
                                    (item) =>
                                      item.item_name
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase()) ||
                                      item.item_name
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase())
                                  ).filter((item) => item.checked == true)
                                    .length == checkedQuantities.length
                                    ? true
                                    : false
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col items-center justify-start mt-0 w-full">
                        <div className="md:gap-5 gap-[50px] grid md:grid-cols-1 grid-cols-1 justify-center min-h-[auto] w-full">
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full overflow-auto min-h-[400px]">
                            <table
                              className="min-w-full  font-inter whitespace-nowrap text-gray-800 text-sm text-left dark:text-gray-400 "
                            >
                              <thead className="text-sm w-full border-2 text-gray-800 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                <tr className="bg-gray-200">
                                  <th className="px-6 py-4">
                                    <label>
                                      <input
                                        type="checkbox"
                                        onClick={handleSelectAll}
                                        className="rounded-[5px]"
                                        checked={selectAllChecked}
                                      />
                                      {"   "} All
                                    </label>
                                  </th>

                                  <th className="px-6 py-4">ITEM NAME</th>

                                  <th className="px-6 py-4">CODE</th>

                                  <th className="px-6 py-4">PROVIDED CODE</th>

                                  <th className="px-6 py-4">QUANTITY</th>

                                  {selectedWarehouseType === "multiple" && (
                                    <th className="px-6 py-4">WAREHOUSE</th>
                                  )}
                                  <th className="px-6 py-4">DESCRIPTION</th>
                                </tr>
                              </thead>
                              <tbody className="text-gray-800 border-2">
                                {checkedQuantities
                                  .filter(
                                    (item) =>
                                      item.quantity_accepted > 0 &&
                                      (item.item_name
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase()) ||
                                        item.item_code
                                          .toLowerCase()
                                          .includes(searchTerm.toLowerCase()) ||
                                        item.item_code_op
                                          .toLowerCase()
                                          .includes(searchTerm.toLowerCase()))
                                  )
                                  .map((item) => (
                                    <tr key={item.id}>
                                      <td className="px-6 py-4">
                                        <input
                                          className="rounded-[5px]"
                                          type="checkbox"
                                          id={`item-${item.id}`}
                                          checked={item.checked}
                                          onChange={() => handleToggle(item.id)}
                                        />
                                      </td>
                                      <td className="px-6 py-4">
                                        {item.item_name}
                                      </td>
                                      <td className="px-6 py-4">
                                        {item.item_code}
                                      </td>
                                      <td className="px-6 py-4">
                                        {item.item_code_op}
                                      </td>
                                      <td className="px-6 py-4">
                                        {item.quantity_accepted}
                                      </td>

                                      {selectedWarehouseType === "multiple" && (
                                        <td className="px-6 py-4">
                                          <Select
                                            name={`warehouse_${item.id}`}
                                            options={wareHouse.map(
                                              (resstate) => ({
                                                label: resstate.warehouse_name,
                                                value: resstate.id,
                                              })
                                            )}
                                            className="bg-white-A700 border border-gray-200_02 border-solid h-9 rounded-[5px] w-full"
                                            onChange={(selectedOption) => {
                                              setCheckedQuantities(
                                                (prevItems) =>
                                                  prevItems.map((prevItem) =>
                                                    prevItem.id === item.id
                                                      ? {
                                                          ...prevItem,
                                                          warehouse:
                                                            selectedOption.value,
                                                        }
                                                      : prevItem
                                                  )
                                              );
                                              setSelectedWarehouses(
                                                (prevSelected) => ({
                                                  ...prevSelected,
                                                  [item.id]:
                                                    selectedOption.value,
                                                })
                                              );
                                            }}
                                            onBlur={formik.handleBlur}
                                            placeholder="Select warehouse"
                                            required={item.checked}
                                          />
                                        </td>
                                      )}
                                      <td className="px-6 py-4">
                                        <input
                                          className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                                          type="text"
                                          value={item.description}
                                          onChange={(e) =>
                                            handleDescriptionChange(
                                              item.id,
                                              e.target.value
                                            )
                                          }
                                          disabled={!item.checked}
                                        />
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </Modal>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </div>
  );
};

export default JobWorkInwardtoStore;
